/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { Button, message, Table, Tag, Typography } from 'antd'
import moment from 'moment'
import ModalDetail from './modalDetail'
import ModalMeal from './modalMeal'
import {
    changeStringTime,
    changeStringTime2,
    changeToDecimal,
    copyToClip,
    fenToYuan,
    isDefaultYear,
} from '../../../util'
import { exportPurchaseRecord, exportBillRemarks } from '../action'
import ReserveDetail from './reserveDetail'

// CSV 单元格清洗
// 1. 换行/制表符压成空格：否则一条记录会横跨两个物理行，Excel 会错位
// 2. 逗号直接替换成 - ：不再依赖引号转义，任何查看器都不会被撑列
// 3. 若还残留双引号，整格加引号并把内部引号翻倍
const csvEscape = (value) => {
    if (value == null) return 'CCBS用户'
    const str = String(value)
        .replace(/[\r\n\t]+/g, ' ')
        .replace(/,/g, '，')
        .trim()
    return str.includes('"') ? '"' + str.replace(/"/g, '""') + '"' : str
}

// 组装 CSV 内容：表头 + 数据行（表头同样要转义，否则标题含逗号/引号时整表错位）
const buildCsv = (columns, list, getValue) => {
    const header = columns.map((col) => csvEscape(col.title)).join(',')
    const body = list
        .filter((item) => item !== undefined)
        .map((item) => columns.map((col) => csvEscape(getValue(col, item))).join(','))
        .join('\n')
    return 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(header + '\n' + body)
}

// 通用取值（营业记录 3/4、备注记录 remark 等）
const getCommonValue = (column, item) => {
    const key = column.dataIndex
    // 订单号/流水号前加 ~ 防止 Excel 显示为科学计数法
    if (key === 'temporary_number' || key === 'serial_number') return '~' + item[key]
    if (key === 'paid_in') return item.price - item.paid_in
    if (key === 'amount') return (item[key] / 100).toFixed(2)
    if (key === 'start_time' || key === 'end_time') return isDefaultYear(changeStringTime2(item[key]))
    return item[key]
}

// 5：预约账单（嵌套 bills[0]）
const getBillValue = (column, item) => {
    const key = column.dataIndex[2]
    if (key === 'temporary_number' || key === 'serial_number') return '~' + item.bills[0][key]
    if (key === 'paid_in') return (Number(item.bills[0].paid_in || 0) / 100).toFixed(2)
    return item.bills[0][key]
}

// 2：充值记录
const getType2Value = (column, item) => {
    const key = column.dataIndex
    if (key === 'serial_number') return '~' + item.serial_number
    if (key === 'amount') return (item.amount / 100).toFixed(2) || '0'
    return item[key] || '-'
}

// 1：营业记录
const getType1Value = (column, item) => {
    const key = column.dataIndex
    if (key === 'temporary_number' || key === 'serial_number') return '~' + item[key]
    return item[key]
}

// 6：球台消费记录
const getType6Value = (column, item) => {
    const key = column.key
    switch (key) {
        case 'table': return item.table.name || '-'
        case 'duration': return (item.duration / 60).toFixed(1) + '分钟' || '-'
        case 'totalAmount': return (item.totalAmount / 100).toFixed(2) || '-'
        case 'employee': return item.employee && item.employee.name ? item.employee.name : '-'
        case 'note': return item.note || '-'
        case 'serialNumber': return '~' + item.serialNumber
        case 'stateDescription': return item.stateDescription
        case 'createTime': return isDefaultYear(changeStringTime2(item.createTime))
        case 'startTime': return isDefaultYear(changeStringTime2(item.startTime))
        case 'finishTime': return isDefaultYear(changeStringTime2(item.finishTime))
        default: return '-'
    }
}

// 7：团购核销记录
const getType7Value = (column, item) => {
    const key = column.key
    if (key === 'amount') return (item.groupon.amount / 100).toFixed(2) || '-'
    if (key === 'tableName') return item.table.name || '-'
    if (key === 'grouponName') return item.groupon.name || '-'
    if (key === 'platformName') return item.platform.name || '-'
    return item.journal[key] || '-'
}

// 按记录类型取对应的取值函数
const resolveGetValue = (tableRecordType) => {
    return {
        '1': getType1Value,
        '2': getType2Value,
        '5': getBillValue,
        '6': getType6Value,
        '7': getType7Value,
    }[tableRecordType] || getCommonValue
}

export default class extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            mealVisible: false,
            mealArr: [],
            selected_account: '',
            selected_nickname: '',
            reserveVisible: false,
            reserveRecord: {},
        }
    }

    //导出报表
    clickDownload = (columns, list, tableRecordType) => {
        return buildCsv(columns, list, resolveGetValue(tableRecordType))
    }

    onShowModal = async (record) => {
        await this.props.settingsPurchases([])
        await this.props.fetchRecordDetails(record.serial_number) //详情
        const aryData = await this.props.getPurchaseServices({ billIds: record.id })
        await this.props.settingsPurchases([].concat(aryData))

        this.setState({
            visible: true,
            selected_account: record.account,
            selected_nickname: record.nickname,
        })
    }

    exportDetail = (reportName) => async () => {
        const { period, list, statisticType, activeTab } = this.props
        if (
            period &&
            period.start_time &&
            period.end_time &&
            list &&
            list.length > 0
        ) {
            const cid = sessionStorage.getItem('club_id')
            const body = {
                club_id: cid,
                start_time: moment(period.start_time).format('YYYY-MM-DD HH:mm:ss'),
                end_time: moment(period.end_time).format('YYYY-MM-DD HH:mm:ss'),
                statisticType,
            }
            let res
            if (activeTab === 'remark') {
                res = await exportBillRemarks(body)
            } else {
                res = await exportPurchaseRecord({
                    clubId: cid,
                    startTime: moment(period.start_time).format('YYYY-MM-DD HH:mm:ss'),
                    endTime: moment(period.end_time).format('YYYY-MM-DD HH:mm:ss'),
                    statisticType,
                })
            }
            if (res) {
                const a = document.createElement('a')
                let href = window.URL.createObjectURL(res)
                a.href = href
                a.download = decodeURIComponent(`订单详情-${reportName}.xls`)
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                window.URL.revokeObjectURL(href)
            } else {
                message.error('导出失败')
            }
        }
    }

    handleOk = () => {
        this.setState({ visible: false })
    }
    handleCancel = () => {
        this.setState({ visible: false })
    }

    //求和(金额)
    priceSum = (list) => {
        let sum = 0
        list.map((item) => {
            sum += item
        })
        return sum.toFixed(2) || 0
    }

    handleReserveOk = () => {
        this.setState({ reserveVisible: false })
    }
    handleReserveCancel = () => {
        this.setState({ reserveVisible: false })
    }

    render() {
        const {
            list,
            table_record_type,
            recordDetail,
            serviceList,
            period,
            record_type_name,
            incomeSumList,
            activeTab,
        } = this.props
        let columns = []
        if (table_record_type === '1') {
            columns = [
                {
                    title: 'id',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '俱乐部名称',
                    dataIndex: 'club_name',
                    key: 'club_name',
                },
                {
                    title: '订单号',
                    dataIndex: 'temporary_number',
                    key: 'temporary_number',
                },
                {
                    title: '流水号',
                    dataIndex: 'serial_number',
                    key: 'serial_number',
                },
                {
                    title: '台名',
                    dataIndex: 'table_name',
                    key: 'table_name',
                },
                {
                    title: '名称',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '支付账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '支付时间',
                    dataIndex: 'time',
                    key: 'time',
                },
                {
                    title: '支付方式',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '金额',
                    dataIndex: 'price',
                    key: 'price',
                },
                {
                    title: '实收',
                    dataIndex: 'paid_in',
                    key: 'paid_in'
                },
                {
                    title: '操作',
                    dataIndex: 'edit',
                    key: 'edit',
                    render: (text, record, index) => {
                        return (
                            <div
                                style={{ color: '#108EE9', cursor: 'default' }}
                                onClick={() => this.onShowModal(record)}
                            >
                                <span>详情</span>
                            </div>
                        )
                    },
                },
            ]
        } else if (table_record_type === '2') {
            columns = [
                {
                    title: 'id',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '用户',
                    dataIndex: 'member_name',
                    key: 'member_name',
                },
                {
                    title: '昵称',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '流水号',
                    dataIndex: 'serial_number',
                    key: 'serial_number',
                },
                {
                    title: '充值账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '支付方式',
                    dataIndex: 'payment_name',
                    key: 'payment_name',
                },
                {
                    title: '充值钱包',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '充值金额',
                    dataIndex: 'amount',
                    key: 'amount',
                    render: (text) => {
                        return (text / 100).toFixed(2)
                    }
                },
                {
                    title: '充值时间',
                    dataIndex: 'ctime',
                    key: 'ctime',
                },
                {
                    title: '操作人',
                    dataIndex: 'employee_name',
                    key: 'employee_name',
                },
            ]
        } else if (table_record_type === '3') {
            columns = [
                {
                    title: 'id',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '用户',
                    dataIndex: 'member_name',
                    key: 'member_name',
                },
                {
                    title: '昵称',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '流水号',
                    dataIndex: 'serial_number',
                    key: 'serial_number',
                },
                {
                    title: '购买账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '支付方式',
                    dataIndex: 'payment_name',
                    key: 'payment_name',
                },
                {
                    title: '卡券名称',
                    dataIndex: 'coupon_name',
                    key: 'coupon_name',
                },
                {
                    title: '卡券面额',
                    dataIndex: 'denomination',
                    key: 'denomination',
                },
                {
                    title: '卡券类型',
                    dataIndex: 'type_id',
                    key: 'type_id',
                    render: (a, b, c) => {
                        return +b.type_id === 1 ? '金额券' : '钟时券'
                    },
                },
                {
                    title: '购买金额',
                    dataIndex: 'amount',
                    key: 'amount',
                    render: (text) => {
                        return (text / 100).toFixed(2)
                    }
                },
                {
                    title: '购买时间',
                    dataIndex: 'ctime',
                    key: 'ctime',
                },
            ]
        } else if (table_record_type === '4') {
            columns = [
                {
                    title: 'id',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '订单号',
                    dataIndex: 'temporary_number',
                    key: 'temporary_number',
                },
                {
                    title: '台名',
                    dataIndex: 'table_name',
                    key: 'table_name',
                },
                {
                    title: '套餐名称',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '开始时间',
                    dataIndex: 'start_time',
                    key: 'start_time',
                    render: (text) => {
                        return changeStringTime2(text)
                    },
                },
                {
                    title: '结束时间',
                    dataIndex: 'end_time',
                    key: 'end_time',
                    render: (text) => {
                        return changeStringTime2(text)
                    },
                },
                {
                    title: '金额',
                    dataIndex: 'amount',
                    key: 'amount',
                    render: (text) => {
                        return (text / 100).toFixed(2)
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'edit',
                    key: 'edit',
                    render: (text, record, index) => {
                        return (
                            <div
                                style={{ color: '#108EE9', cursor: 'default' }}
                                onClick={() =>
                                    this.setState({
                                        mealVisible: true,
                                        mealArr: record.bills ? record.bills : [],
                                    })
                                }
                            >
                                <span>详情</span>
                            </div>
                        )
                    },
                },
            ]
        } else if (table_record_type === '5') {
            columns = [
                {
                    title: 'id',
                    dataIndex: ['bills', '0', 'id'],
                    key: 'id',
                },
                {
                    title: '订单号',
                    dataIndex: ['bills', '0', 'serial_number'],
                    key: 'serial_number',
                },
                {
                    title: '用户',
                    dataIndex: ['bills', '0', 'member_name'],
                    key: 'member_name',
                },
                {
                    title: '手机号',
                    dataIndex: ['bills', '0', 'phone'],
                    key: 'phone',
                },
                {
                    title: '支付时间',
                    dataIndex: ['bills', '0', 'paying_time'],
                    key: 'paying_time',
                    render: (text) => {
                        return isDefaultYear(changeStringTime2(text))
                    },
                },
                {
                    title: '支付金额',
                    dataIndex: ['bills', '0', 'amount'],
                    key: 'amount',
                },
                {
                    title: '实收金额',
                    dataIndex: ['bills', '0', 'paid_in'],
                    key: 'paid_in',
                    render: (text) => {
                        if (text) {
                            return (text / 100).toFixed(2)
                        }
                    }
                },
                {
                    title: '到店时间',
                    dataIndex: ['bills', '0', 'consume_time'],
                    key: 'consume_time',
                    render: (text) => {
                        return isDefaultYear(changeStringTime2(text))
                    },
                },
                // {
                //   title: '操作',
                //   dataIndex: 'edit',
                //   key: 'edit',
                //   render: (text, record, index) => {
                //     return (
                //       <div
                //         style={{ color: '#108EE9', cursor: 'default' }}
                //         onClick={() =>
                //           this.setState({
                //             reserveRecord: record,
                //             reserveVisible: true,
                //           })
                //         }
                //       >
                //         <span>详情</span>
                //       </div>
                //     )
                //   },
                // },
            ]
        } else if (table_record_type === '6') {
            columns = [
                {
                    title: '球台',
                    dataIndex: 'table',
                    key: 'table',
                },
                {
                    title: '时长',
                    dataIndex: 'duration',
                    key: 'duration',
                    render: (text) =>
                        <div>{(text / 60).toFixed(1)}分钟</div>
                },
                {
                    title: '金额',
                    dataIndex: 'totalAmount',
                    key: 'totalAmount',
                    render: (text) =>
                        <div>{(text / 100).toFixed(2)}元</div>

                },
                {
                    title: '员工',
                    dataIndex: 'employee',
                    key: 'employee',
                },
                {
                    title: '备注',
                    dataIndex: 'note',
                    key: 'note'
                },
                {
                    title: '流水号',
                    dataIndex: 'serialNumber',
                    key: 'serialNumber',
                    render: (text) =>
                        <Typography.Text copyable>{text}</Typography.Text>
                },
                {
                    title: '状态',
                    dataIndex: 'stateDescription',
                    key: 'stateDescription',
                    render: (text) => {
                        switch (text) {
                            case '已创建':
                                return <Tag color="lime">{text}</Tag>
                            case '已开始':
                                return <Tag color="blue">{text}</Tag>
                            case '已完成':
                                return <Tag color="green">{text}</Tag>
                        }
                    }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    render: (text) => {
                        return isDefaultYear(changeStringTime2(text))
                    },
                },
                {
                    title: '开始时间',
                    dataIndex: 'startTime',
                    key: 'startTime',
                    render: (text) => {
                        return isDefaultYear(changeStringTime2(text))
                    },
                },
                {
                    title: '结束时间',
                    dataIndex: 'finishTime',
                    key: 'finishTime',
                    render: (text) => {
                        return isDefaultYear(changeStringTime2(text))
                    },
                }
            ]
        } else if (table_record_type === '7') {
            {
                columns = [
                    {
                        title: 'id',
                        dataIndex: ['journal', 'id'],
                        key: 'id',
                    },
                    {
                        title: '订单号',
                        dataIndex: ['journal', 'tableStateId'],
                        key: 'tableStateId',
                        render: (text) =>
                            (text != null && text.length > 0 ? <Typography.Text copyable>{text}</Typography.Text> : '-')
                    },
                    {
                        title: '流水号',
                        dataIndex: ['journal', 'serialNumber'],
                        key: 'serialNumber',
                        render: (text) =>
                            (text != null && text.length > 0 ? <Typography.Text copyable>{text}</Typography.Text> : '-')
                    },
                    {
                        title: '团购码',
                        dataIndex: ['journal', 'code'],
                        key: 'code',
                        render: (text) =>
                            (text != null && text.length > 0 ? <Typography.Text copyable>{text}</Typography.Text> : '-')
                    },
                    {
                        title: '台名',
                        dataIndex: ['table', 'name'],
                        key: 'tableName',
                        render: (text) =>
                            (text != null && text.length > 0 ? <Typography.Text copyable>{text}</Typography.Text> : '-')
                    },
                    {
                        title: '团购名称',
                        dataIndex: ['groupon', 'name'],
                        key: 'grouponName',
                    },
                    {
                        title: '团购平台',
                        dataIndex: ['platform', 'name'],
                        key: 'platformName',
                    },
                    {
                        title: '状态',
                        dataIndex: ['journal', 'stateDesc'],
                        key: 'stateDesc',
                        render: (text) => {
                            switch (text) {
                                case '已创建':
                                    return <Tag color="#b4acac">{text}</Tag>
                                case '已完成':
                                    return <Tag color="green">{text}</Tag>
                                case '未核销':
                                    return <Tag color="blue">{text}</Tag>
                                default:
                                    return <Tag color="lime">{text}</Tag>
                            }
                        }
                    },
                    {
                        title: '自助核销',
                        dataIndex: ['journal', 'member_id'],
                        key: 'memberId',
                        render: (text) => (
                            <Tag color={text === "-1" ? 'default' : 'green'}>{text === "-1" ? '否' : '是'}</Tag>
                        )
                    },
                    {
                        title: '开始时间',
                        dataIndex: ['journal', 'startTime'],
                        key: 'startTime',
                        render: (text) => {
                            if (!text || new Date(text).getFullYear() === 1970) {
                                return '-'
                            } else {
                                return moment(text).format('YYYY-MM-DD HH:mm:ss')
                            }
                        }
                    },
                    {
                        title: '结束时间',
                        dataIndex: ['journal', 'finishTime'],
                        key: 'finishTime',
                        render: (text) => {
                            if (!text || new Date(text).getFullYear() === 1970) {
                                return '-'
                            } else {
                                return moment(text).format('YYYY-MM-DD HH:mm:ss')
                            }
                        }
                    },
                    {
                        title: '金额',
                        dataIndex: ['groupon', 'amount'],
                        key: 'amount',
                        render: (text) =>
                            (text / 100).toFixed(2)
                    },
                ]
            }
        } else if (table_record_type === 'remark') {
            columns = [
                {
                    title: '订单号',
                    dataIndex: 'temporary_number',
                    key: 'temporary_number',
                },
                {
                    title: '流水号',
                    dataIndex: 'serial_number',
                    key: 'serial_number',
                    render: (text) =>
                        text != null ? <Typography.Text copyable>{text}</Typography.Text> : '-'
                },
                {
                    title: '俱乐部',
                    dataIndex: 'club_name',
                    key: 'club_name',
                },
                {
                    title: '球台',
                    dataIndex: 'table_name',
                    key: 'table_name',
                },
                {
                    title: '会员昵称',
                    dataIndex: 'nickname',
                    key: 'nickname',
                },
                {
                    title: '结账账号',
                    dataIndex: 'account',
                    key: 'account',
                },
                {
                    title: '支付方式',
                    dataIndex: 'payment_name',
                    key: 'payment_name',
                },
                {
                    title: '金额',
                    dataIndex: 'price',
                    key: 'price',
                },
                {
                    title: '实收',
                    dataIndex: 'paid_in',
                    key: 'paid_in',
                },
                {
                    title: '找零',
                    dataIndex: 'change',
                    key: 'change',
                },
                {
                    title: '备注',
                    dataIndex: 'note',
                    key: 'note',
                },
                {
                    title: '员工',
                    dataIndex: 'employee_name',
                    key: 'employee_name',
                },
                {
                    title: '结账时间',
                    dataIndex: 'ctime',
                    key: 'ctime',
                    render: (text) => {
                        return isDefaultYear(changeStringTime2(text))
                    },
                },
            ]
        }


        const data = list.map((item) => {
            if (table_record_type !== '6') {
                return item
            } else {
                return {
                    id: item.id,
                    table: item.table.name,
                    duration: item.duration,
                    totalAmount: item.totalAmount,
                    employee: item.employee && item.employee.name ? item.employee.name : "-",
                    note: item.note,
                    serialNumber: item.serialNumber,
                    stateDescription: item.stateDescription,
                    createTime: item.createTime,
                    startTime: item.startTime,
                    finishTime: item.finishTime
                }
            }
        })

        let reportName = sessionStorage.getItem('reportName')
        if (period && period.start_time && period.end_time) {
            reportName += `${changeStringTime(period.start_time)}-${changeStringTime(
                period.end_time
            )}`
        }

        const sum = fenToYuan(this.priceSum(incomeSumList))
        return (
            <div style={{ marginTop: '1rem' }}>
                <div
                    style={{
                        cursor: 'default',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginBottom: '1rem',
                    }}
                >
                    <Button>
                        <a
                            id="test"
                            href={this.clickDownload(columns || [], list, table_record_type)}
                            download={`${reportName}${record_type_name ? '-' + record_type_name : ''
                                }.csv`}
                        >
                            导出
                        </a>
                    </Button>

                    <div>
                        <Button
                            style={{ marginRight: '30px' }}
                            onClick={this.exportDetail(reportName)}
                        >
                            导出详细内容
                        </Button>
                        <Button type="primary" ghost onClick={() => copyToClip(sum)}>
                            实收合计:￥{sum}元
                        </Button>
                    </div>
                </div>
                <h3>{activeTab === 'remark' ? '备注记录' : '营业记录'}</h3>
                <Table
                    rowKey="id"
                    bordered
                    columns={columns}
                    dataSource={data}
                    size="middle"
                />

                <ModalDetail
                    {...this.state}
                    list={recordDetail}
                    serviceList={serviceList}
                    handleOk={this.handleOk}
                    handleCancel={this.handleCancel}
                    selected_account={this.state.selected_account}
                    selected_nickname={this.state.selected_nickname}
                />

                <ModalMeal
                    {...this.state}
                    visible={this.state.mealVisible}
                    list={this.state.mealArr}
                    handleOk={() => this.setState({ mealVisible: false })}
                    handleCancel={() => this.setState({ mealVisible: false })}
                />

                {this.state.reserveVisible && (
                    <ReserveDetail
                        visible={this.state.reserveVisible}
                        record={this.state.reserveRecord}
                        handleReserveOk={this.handleReserveOk}
                        handleReserveCancel={this.handleReserveCancel}
                    ></ReserveDetail>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/component/report.js